module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.value || _vm.checked
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input', $event.target.checked)
      },
      "change": function($event) {
        return _vm.$emit('change', $event.target.checked)
      }
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._t("label")], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "cr"
  }, [_c('i', {
    staticClass: "cr-icon glyphicon glyphicon-ok"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5178346e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Utils/Inputs/Checkbox.vue
// module id = 805
// module chunks = 1